export const formatRows = (listaItems) =>
  listaItems.map((item) => ({
    id: item.id || "Id no disponible",
    mar_codigo: item.mar_codigo || "Código de marca no disponible",
    mar_descripcion: item.mar_descripcion || "Marca no disponible",
    mar_imagen: item.mar_imagen || "Imagen no disponible",  // Puedes cambiar este texto si lo necesitas
    web: item.mar_show_web === 0 ? "✅" : "❌",
    app: item.mar_show_app === 0 ? "✅" : "❌",
  }));
